
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.166 7.076A2.864 2.864 0 0014 5.006a3.048 3.048 0 00-.898-2.108A3.048 3.048 0 0010.993 2a2.904 2.904 0 00-1.125.21 2.832 2.832 0 00-.944.624l-2.121 2.12-.708-.706 2.122-2.122a3.832 3.832 0 011.277-.844A3.905 3.905 0 0111.006 1a4.048 4.048 0 012.803 1.19A4.048 4.048 0 0115 4.995a3.865 3.865 0 01-1.125 2.79l-2.122 2.12-.707-.707 2.121-2.12zM2.834 8.924A2.865 2.865 0 002 10.994c.01.783.332 1.543.898 2.108A3.048 3.048 0 005.007 14a2.89 2.89 0 001.125-.21 2.84 2.84 0 00.944-.623l2.121-2.122.708.707-2.122 2.122a3.833 3.833 0 01-1.277.844A3.906 3.906 0 014.994 15a4.048 4.048 0 01-2.803-1.19A4.048 4.048 0 011 11.005a3.865 3.865 0 011.125-2.79l2.122-2.12.707.707-2.121 2.12zm3.398 1.55l4.243-4.242-.707-.707-4.243 4.243.707.707z","fill":"currentColor"}})])
          )
        }
      }
    